import { useQuery, useQueryClient } from '@tanstack/react-query'
import { Disponibilidad } from '../../data/types/disponibilidad.types'
import { api } from '../../data/api'

const fetchDisponibilidades = async (fechaDesde: string, fechaHasta: string): Promise<Disponibilidad[]> => {
	const response = await api.get(
		`/api/disponibilidades/byMedico?fechaDesde=${fechaDesde}&fechaHasta=${fechaHasta}`
	)
	return response.data
}

export const useDisponibilidadesMedico = (
	fechaDesde: string,
	fechaHasta: string,
) => {
	const queryClient = useQueryClient()
	const query = useQuery<Disponibilidad[], Error>({
		queryKey: ['disponibilidades', fechaDesde, fechaHasta],
		queryFn: () => fetchDisponibilidades(fechaDesde, fechaHasta),
		enabled: fechaDesde !== undefined && fechaDesde !== '' && fechaHasta !== undefined && fechaHasta !== ''
	})

	// Función para invalidar y refrescar las disponibilidades
	const invalidateDisponibilidades = async () => {
		try {
			// Invalidar todas las queries de disponibilidades (sin exact: true, invalida todas las que empiecen con ['disponibilidades'])
			await queryClient.invalidateQueries({
				queryKey: ['disponibilidades']
			})
		} catch (error) {
			console.error('❌ Error al invalidar disponibilidades:', error)
		}
	}

	// Función de invalidación más agresiva como fallback
	const forceRefreshDisponibilidades = async () => {
		try {
			// Invalidar todas las queries de disponibilidades
			await queryClient.invalidateQueries({
				queryKey: ['disponibilidades']
			})
			
			// Forzar refetch de la query actual
			await queryClient.refetchQueries({
				queryKey: ['disponibilidades', fechaDesde, fechaHasta]
			})
		} catch (error) {
			console.error('❌ Error en refresh forzado:', error)
		}
	}

	return {
		...query,
		invalidateDisponibilidades,
		forceRefreshDisponibilidades
	}
}

